<template>
    <div>
        <a-modal v-model="isVisible" :closable="false" title="Send Message To Restaurant" on-ok="handleOk">
            <template slot="footer">
                <a-button key="back" @click="handleCancel">
                    Close
                </a-button>
                <a-button type="primary" @click="handleSend">
                    Send
                </a-button>
            </template>
            <a-row>
                <a-form-model :rules="messageRules" :model="messageModel" ref="messageForm">
                    <a-row :gutter="[24]">
                        <a-col :span="12">
                            <a-form-model-item label="Restaurant" ref="selectedRestaurant" props="selectedRestaurant">
                                <a-select @select="handleRestaurantOptionSelect" v-model="messageModel.selectedRestaurant">
                                    <template v-for="r in restaurants">
                                        <a-select-option :key="r.restaurantId">
                                            {{r.restaurantName}}
                                        </a-select-option>
                                    </template>
                                </a-select>
                            </a-form-model-item>
                            
                            
                        </a-col>
                        <a-col :span="12">
                            <a-form-model-item label="Sender">
                                <a-input v-model="messageModel.sender"/>
                            </a-form-model-item>
                        </a-col>

                    </a-row> 
                    
                    <a-row :gutter="[24]">
                       

                        <a-col :span="24">
                            <a-form-model-item label="Message">
                                <a-input v-model="messageModel.message" type="textarea"/>
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                </a-form-model>
            </a-row>
        </a-modal>
       
    </div>
</template>

<script>
import moment from 'moment';
import TimeFormatter from '../../common/utils/TimeFormatter'
import { mapState } from 'vuex'
import messageService from '../../services/message/commands'

export default {

    data () {
        return {
            messageRules : {
                selectedRestaurant : [
                    {
						required : true,
						message : 'Please choose restaurant'
					}
                ],
                sender : [
                    {
						required : true,
						message : 'The field cannot be empty',
						trigger: 'blur'
					},
					{
						min: 3,
						message : 'The field should have at least 3 characters',
						trigger: 'blur'
					}
                ],
                message : [
                    {
						required : true,
						message : 'The field cannot be empty',
						trigger: 'blur'
					},
					{
						min: 10,
						message : 'The field should have at least 10 characters',
						trigger: 'blur'
					}
                ]
            }
                
            ,
            isVisible : false,
            
            messageModel : {
                sender : 'Admin',
                message : '',
                selectedRestaurant : null
            }
            
        }
    },

    computed : {
        ...mapState({
            restaurants : state => state.phoneService.restaurants
        })
    },
    
    methods : {

        showModal() {
            //console.log(order)
            this.isVisible = true;
            
        },

        handleOk ()  {
            this.reset();
        },
        handleCancel () {
            this.reset();
        },

        handleSend() {
            this.$refs.messageForm.validate(async valid => {
                if (valid) {
                    this.$message.loading('Sending message to restaurant...', 0);

                    let token = this.$store.state.auth.auth.token;
                    let data = {
                        restaurantId : this.messageModel.selectedRestaurant,
                        sender : this.messageModel.sender,
                        message : this.messageModel.message
                    };
                    console.log(data)

                    await messageService.createMessagePrintPage(data, token);

                    this.$message.destroy();
                    this.reset();
                }
            });
            
        },
        handleRestaurantOptionSelect(e) {
            this.messageModel.selectedRestaurant = e;
            console.log(e)
        },

        
        reset() {
            this.isVisible = false;
            this.messageModel.message = null;
            this.messageModel.selectedRestaurant = null;
        }
    }
}
</script>

<style>

</style>